<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.previsaoCompra.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.previsaoCompra.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.previsaoCompra.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row" *ngIf="!carregando">
            <div class="div-check">
              <input id="check" type="checkbox" [checked]="todos" (change)="todosdelaer()" />
              <label translate class="label-check" for="check">{{'parametros.previsaoCompra.cadastro.dadosPrincipais.todosOsDealers'}}</label>
            </div>
          </div>
          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5" *ngIf="todos == false"
              label="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.dealer' | translate}}" name="dealer"
              [(ngModel)]="model.id_dealer" obrigatorio="true" required filtro="dealer"></app-dropdown-list-api>
          </div>
          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.tipo' | translate}}" name="tipo"
              [(ngModel)]="model.id_categoria_compra" required [itens]="itensTipo" filtro="categoria_compra">
            </app-dropdown-list-api>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.ano' | translate}}" name="ano"
              [(ngModel)]="model.ano" obrigatorio="true" required
              placeholder="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.anoPlaceHolder' | translate}}">
            </app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.mes' | translate}}" name="tipoDealer"
              [(ngModel)]="model.mes" required [itens]="meses"></app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box-currency [state]="state" class="col-lg-10"
              label="{{'parametros.previsaoCompra.cadastro.dadosPrincipais.valorPrevisao' | translate}}"
              name="valor_previsao" [(ngModel)]="model.valor" obrigatorio="true" required
              placeholder="R$..." >
            </app-text-box-currency>
          </div>
          <hr />
          <div class="jumbotron">
            <div class="row">
              <div class="col-10">
                <legend translate>{{'parametros.previsaoCompra.cadastro.dadosPrincipais.legenda1'}}</legend>
                <legend translate>{{'parametros.previsaoCompra.cadastro.dadosPrincipais.legenda2'}}</legend>
                <legend translate>{{'parametros.previsaoCompra.cadastro.dadosPrincipais.legenda3'}}</legend>
                <legend translate>{{'parametros.previsaoCompra.cadastro.dadosPrincipais.legenda4'}}</legend>
                <legend translate>{{'parametros.previsaoCompra.cadastro.dadosPrincipais.legenda5'}}</legend>
              </div>
              <div class="col-2">
                <div class="float-right mr-4">
                  <a class="btn download" href="assets/modelos/modelo-previsao-compra.xlsx">
                    <i class="fas fa-file-download"></i>
                  </a>
                  {{'parametros.previsaoCompra.cadastro.dadosPrincipais.modelo' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="state == 1">
            <div class="col col-lg-12">
              <p translate class="text-info">{{'parametros.previsaoCompra.cadastro.dadosPrincipais.adicionarArquivoXlsCadastro'}}</p>
              <p-fileUpload mode="advanced" fileLimit="1" name="myfile[]" customUpload="true" accept=".xlsx"
                (uploadHandler)="Uploader($event)"></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
